import {Injectable} from '@angular/core';
import {BaseService} from "./BaseService";
import {Observable} from "rxjs";
import {ChangeUserOwnerCB} from "../../Ope/CustomerUser/ChangeUserOwnerCB";
import {GetCustomerUsersCB} from "../../Ope/CustomerUser/GetCustomerUsersCB";
import {GetUserTokenCB} from "../../Ope/CustomerUser/GetUserTokenCB";
import {PutCustomerUserCB} from "../../Ope/CustomerUser/PutCustomerUserCB";
import {DelCustomerUserCB} from "../../Ope/CustomerUser/DelCustomerUserCB";
import {ResetPasswordByEmailCB} from "../../Ope/CustomerUser/ResetPasswordByEmailCB";

@Injectable({
  providedIn: 'root'
})
export class CustomerUserService extends BaseService {

  public changeUserOwner(cb: ChangeUserOwnerCB): Observable<any> {
    return this.execOPE(cb);
  }

  public delCustomerUser(cb: DelCustomerUserCB): Observable<any> {
    return this.execOPE(cb);
  }

  public getCustomerUsers(cb: GetCustomerUsersCB): Observable<any> {
    return this.execOPE(cb);
  }

  public getUserToken(cb: GetUserTokenCB): Observable<any> {
    return this.execOPE(cb);
  }

  public putCustomerUser(cb: PutCustomerUserCB): Observable<any> {
    return this.execOPE(cb);
  }

  public resetPasswordByEmail(cb: ResetPasswordByEmailCB): Observable<any> {
    return this.execOPE(cb);
  }

}
